import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { VehicleEntity } from "./vehicle.entity";
import { DataSource, Repository } from "typeorm";
import { CommonResponseModel, PlantIdReq, VehicleStatusenum, VehicleTypeEnum, VehicleTypeReq } from "@project-management-system/shared-models";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import * as moment from 'moment';
import { VehicleDto } from "./vehicle.dto";
import { UploadResponse } from 'packages/libs/shared-models/src/common/vms/masters/vehicles/uploadfile-response';


@Injectable()
export class VehicleService {
  constructor(
    @InjectRepository(VehicleEntity)
    private repo: Repository<VehicleEntity>,
    private readonly dataSource: DataSource
  ) { }

  async createVehicle(req: any): Promise<CommonResponseModel> {
    //to add dto

    try {
      const Check = await this.repo.find({
        where: {
          // vehicleName: req.vehicleName,
          registrationNumber: req.registrationNumber,
        },
      });
      let save
      if (Check.length > 0) {
        return new CommonResponseModel(false, 0, "registration number already exists");
      } else {
        const entity = new VehicleEntity();
        entity.vehicleName = req.vehicleName;
        entity.vehicleCapacity = req.vehicleCapacity;
        entity.vehicleType = req.vehicleType;
        entity.markOrModel = req.markOrModel;
        entity.markModelId = req.markModelId;
        entity.yearofManufacture = req.yearofManufacture;
        entity.vehicleCategory = req.vehicleCategory;
        // entity.upload = req.upload;
        entity.vehicleStatus = VehicleStatusenum.NOT_OCCUPIED;
        entity.registrationNumber = req.registrationNumber;
        // entity.engineNumber = req.engineNumber;
        entity.chassisNumber = req.chassisNumber;
        entity.fuleType = req.fuleType;
        entity.fuelMesureMentIn = req.fuelMesureMentIn;
        // entity.trackUsageAs = req.trackUsageAs;
        entity.secondaryOrAuxilaryMeter = req.secondaryOrAuxilaryMeter;
        entity.insuranceNumber = req.insuranceNumber;
        // entity.insuranceStartDate = req.insuranceStartDate;
        entity.insuranceExpiryDate = req.insuranceExpiryDate;
        entity.roadTexNo = req.roadTexNo;
        entity.roadTexLastDate = req.roadTexLastDate;
        entity.nationalPermitNo = req.nationalPermitNo;
        entity.nationalPermitLastDate = req.nationalPermitLastDate;
        entity.vehicleLastServicingDate = req.vehicleLastServicingDate;
        entity.vehicleServicingDate = req.vehicleServicingDate;
        entity.createdUser = req.createdUser;
        entity.isActive = req.isActive;
        entity.versionFlag = req.versionFlag;
        entity.updatedUser = req.updatedUser;
        entity.vendorId = req.vendorId;
        if (req.id) {
          entity.updatedUser = req.createdUser;
        } else {
          entity.createdUser = req.createdUser;
        }
        save = await this.repo.save(entity);
      }
      if (!save) {
        return new CommonResponseModel(
          false,
          0,
          "Something went wrong in Vehicle creation",
          []
        );
      } else {
        return new CommonResponseModel(true, 1, "Created successfully", save);
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllVehicle(): Promise<CommonResponseModel> {
    try {
      const data = await this.repo.find({ order: { 'vehicleName': 'ASC' } });

      if (data.length > 0) {
        return new CommonResponseModel(
          true,
          1,
          "data retrived Sucessfully",
          data
        );
      }
      return new CommonResponseModel(true, 1, "data retrived Sucessfully", []);
    }
    catch (err) {
      return err;
    }
  }

  async getVehiclesByType(req: VehicleTypeReq): Promise<CommonResponseModel> {
    // console.log(req);
    try{
      let query=`SELECT  
                      v.id,
                      v.vehicle_type AS vehicleType,
                      v.vehicle_capacity AS vehicleCapacity,
                      v.mark_model_id AS markModelId,
                      v.vehicle_category AS vehicleCategoryID,
                      v.vehicle_name AS vehicleName,
                      v.mark_model AS markOrModel,
                      v.year_of_manufacture AS yearofManufacture,
                      v.registration_number AS registrationNumber,
                      v.chassis_number AS chassisNumber,
                      v.fule_type AS fuleType,
                      v.fuel_mesure_mentIn AS fuelMesureMentIn,
                      v.secondary_or_auxiliary_meter AS secondaryOrAuxilaryMeter,
                      v.STATUS AS vehicleStatus,
                      v.insurance_number AS insuranceNumber,
                      v.insurance_expiry_date AS insuranceExpiryDate,
                      v.road_tex_no AS roadTexNo,
                      v.road_tex_last_date AS roadTexLastDate,
                      v.national_permit_no AS nationalPermitNo,
                      v.national_permit_last_date AS nationalPermitLastDate,
                      v.vehicle_servicing_date AS vehicleServicingDate,
                      v.vehicle_last_servicing_date AS vehicleLastServicingDate,
                      v.file_name AS fileName,
                      v.file_path AS filePath,
                      v.vendor_id AS vendorId,
                      vh.vehicle_category AS vehicleCategory,
                      v.is_active as isActive,
                      p.plant_id AS plantId,
                     p.plant_name AS plantName
                      FROM vehicle v
                      LEFT JOIN plants p on p.plant_id = v.plant_id
                      LEFT JOIN vehicle_category vh ON vh.id=v.vehicle_category  where v.id >0`
                      if (req.plant && req.plant) {
                        query += ` and p.plant_name = '${req.plant}'`;
                      }
                      if(req.vehicleType === "VENDOR"){
                        query=query+'and v.vehicle_type ="'+req.vehicleType+'" and v.vendor_id='+req.vendorId+' ORDER BY v.vehicle_name ASC'
                      }
                      else{
                        query=query+' and v.vehicle_type ="'+req.vehicleType+'" ORDER BY v.vehicle_name ASC'
                      }

                     
                      
                      const data = await this.repo.query(query)



      // let data
      // if(req.vehicleType === "VENDOR"){
      //   data = await this.repo.find({where:{vehicleType:req.vehicleType,vendorId:req.vendorId},order:{'vehicleName':'ASC'}});
      // }
      // else{
      //   data = await this.repo.find({where:{vehicleType:req.vehicleType},order:{'vehicleName':'ASC'}});
      // }

      if (data.length > 0) {
        return new CommonResponseModel(
          true,
          1,
          "data retrived Sucessfully",
          data
        );
      }
      return new CommonResponseModel(true, 1, "data retrived Sucessfully", []);
    }
    catch (err) {
      return err;
    }
  }

  async getVehicle(): Promise<CommonResponseModel> {
    try {
      const query = 'select id,mark_model as markOrModel,vehicle_name AS vehicleName,vehicle_capacity as vehicleCapacity from vehicle group by mark_model,vehicle_name,vehicle_capacity'
      const result = await this.repo.query(query)
      if (result) {
        return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully', result)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found ', [])

      }

    } catch (err) {
      throw err
    }
  }

  async getVehicleByPlant(req:PlantIdReq): Promise<CommonResponseModel> {
    try {
      const query = `select id,mark_model as markOrModel,vehicle_name AS vehicleName,vehicle_capacity as vehicleCapacity from vehicle where plant_id = ${req.plantId} group by mark_model,vehicle_name,vehicle_capacity`
      const result = await this.repo.query(query)
      if (result) {
        return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully', result)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found ', [])

      }

    } catch (err) {
      throw err
    }
  }

  
  async getActiveAllVehicle(): Promise<CommonResponseModel> {
    const data = await this.repo.find({
      where: {
        isActive: true,
      },

    });

    if (data.length > 0) {
      return new CommonResponseModel(
        true,
        1,
        "data retrived Sucessfully",
        data
      );
    }
    return new CommonResponseModel(true, 1, "data retrived Sucessfully", []);
  }



  async updateVehicle(req: VehicleDto): Promise<CommonResponseModel> {

    try {
      let Product;
      Product = await this.repo.update(
        { id: req.id },
        {
          vehicleName: req.vehicleName,
          vehicleCapacity: req.vehicleCapacity,
          vehicleType: req.vehicleType,
          markOrModel: req.markOrModel,
          yearofManufacture: req.yearofManufacture,
          // upload: req.upload,
          // status: req.status,
          registrationNumber: req.registrationNumber,
          // engineNumber: req.engineNumber,
          chassisNumber: req.chassisNumber,
          fuleType: req.fuleType,
          fuelMesureMentIn: req.fuelMesureMentIn,
          // trackUsageAs: req.trackUsageAs,
          secondaryOrAuxilaryMeter: req.secondaryOrAuxilaryMeter,
          insuranceNumber: req.insuranceNumber,
          // insuranceStartDate: req.insuranceStartDate,
          insuranceExpiryDate: req.insuranceExpiryDate,
          roadTexNo: req.roadTexNo,
          roadTexLastDate: req.roadTexLastDate,
          nationalPermitNo: req.nationalPermitNo,
          nationalPermitLastDate: req.nationalPermitLastDate,
          vehicleLastServicingDate: req.vehicleLastServicingDate,
          vehicleServicingDate: req.vehicleServicingDate,
          fileName: req.fileName,
          filePath: req.filePath,
          createdUser: req.createdUser,
          isActive: req.isActive,
          versionFlag: req.versionFlag,
          updatedUser: req.updatedUser,
        }

      );
      if (Product.affected > 0) {
        return new CommonResponseModel(
          true,
          11,
          "updated successfully",
          Product
        );
      } else {
        return new CommonResponseModel(false, 11, "update failed", []);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async activateOrDeactivateVehicle(req: any): Promise<CommonResponseModel> {
    //to add dto
    try {
      // console.log(req.isActive, "service-----------");
      const Exists = await this.repo.findOne({ where: { id: req.id } });
      if (Exists) {
        if (!Exists) {
          throw new ErrorResponse(
            10113,
            "Someone updated the current Vehicle information.Refresh and try again"
          );
        } else {
          const update = await this.repo.update(
            { id: req.id },
            { isActive: req.isActive, updatedUser: req.updatedUser }
          );
          if (Exists.isActive) {
            if (update.affected) {
              const Response: CommonResponseModel = new CommonResponseModel(
                true,
                10115,
                "Vehicle is Deactivated successfully"
              );
              return Response;
            } else {
              throw new CommonResponseModel(
                false,
                10111,
                "Vehicle is already deactivated"
              );
            }
          } else {
            if (update.affected) {
              const Response: CommonResponseModel = new CommonResponseModel(
                true,
                10114,
                "Vehicle is activated successfully"
              );
              return Response;
            } else {
              throw new CommonResponseModel(
                false,
                10112,
                "Vehicle is already  activated"
              );
            }
          }
        }
      } else {
        throw new CommonResponseModel(false, 99998, "No Records Found");
      }
    } catch (err) {
      return err;
    }
  }

  async getVehicleDashBoard(): Promise<CommonResponseModel> {
    const vehicleStatusValues = Object.values(VehicleStatusenum)
      .map(status => `'${status}'`)
      .join(', ');
    const query = `
    SELECT COUNT(v.status) AS Count, v.status AS status
    FROM vehicle v
    WHERE status IN (${vehicleStatusValues})
    GROUP BY v.status;`;;
    const result = await this.repo.query(query);
    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrived", result);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }
  async getVehicleServiceDashBoard(): Promise<CommonResponseModel> {
    const lastFiveDatesDate = moment().add(5, 'days').format('YYYY-MM-DD');
    const presentDate = moment().format('YYYY-MM-DD');
    const query = `  SELECT COUNT(vehicle_servicing_date) AS total
    FROM vehicle 
    WHERE DATE(vehicle_servicing_date) BETWEEN "${presentDate}" AND "${lastFiveDatesDate}";
    `;
    const result = await this.repo.query(query);
    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrived", result);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }
  async getVehicleReminder(): Promise<CommonResponseModel> {
    const lastFiveDatesDate = moment().add(5, 'days').format('YYYY-MM-DD');
    const presentDate = moment().format('YYYY-MM-DD');

    const query = `SELECT COUNT(insurance_expiry_date) AS insurancetotal, 
    '${presentDate} to ${lastFiveDatesDate}' AS date_range 
    FROM vehicle 
    WHERE DATE(insurance_expiry_date) BETWEEN "${presentDate}" AND "${lastFiveDatesDate}"`;


    const query2 = `SELECT COUNT(road_tex_last_date) AS roadtotal, 
                   '${presentDate} to ${lastFiveDatesDate}' AS date_range 
                   FROM vehicle 
                   WHERE DATE(road_tex_last_date) BETWEEN "${presentDate}" AND "${lastFiveDatesDate}"`;


    const query3 = `SELECT COUNT(national_permit_last_date) AS nationaltotal, 
                   '${presentDate} to ${lastFiveDatesDate}' AS date_range 
                   FROM vehicle 
                   WHERE DATE(national_permit_last_date) BETWEEN "${presentDate}" AND "${lastFiveDatesDate}"`;

    const result = await this.repo.query(query);
    const result2 = await this.repo.query(query2);
    const result3 = await this.repo.query(query3);

    // console.log(result, result2, result3, "Results");

    if (result.length || result2.length || result3.length) {
      const combinedResults = [
        ...result,
        ...result2,
        ...result3
      ];
      return new CommonResponseModel(true, 1, "Data Retrieved", combinedResults);
    } else {
      return new CommonResponseModel(false, 0, "No Data Retrieved");
    }
  }


  async getAvailableVehiclesList(req: VehicleTypeReq): Promise<CommonResponseModel> {

    let query
    if (req.vehicleType === "Vendor") {
      query = `SELECT v.registration_number AS registrationNumber,v.id AS vehicleId,mark_model AS vehicleType, vehicle_name AS vehicle, vehicle_capacity AS vehicleCapacity from vehicle v left join vehicle_category vc on vc.id = v.vehicle_category where vehicle_type = '` + req.vehicleType + `' and vc.id = ` + req.categoryId + ` and v.vendor_id = ` + req.vendorId + ` order by mark_model ASC `;
    }
    else {
      query = `SELECT v.registration_number AS registrationNumber,v.id AS vehicleId,mark_model AS vehicleType, vehicle_name AS vehicle, vehicle_capacity AS vehicleCapacity from vehicle v left join vehicle_category vc on vc.id = v.vehicle_category where vehicle_type = '` + req.vehicleType + `' and vc.id = ` + req.categoryId + ` order by mark_model ASC `;
    }
    const result = await this.repo.query(query);
    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrived", result);

    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }

  async updatePath(filePath: string, fileName: string, id: any,): Promise<UploadResponse> {
    // console.log('upload service id---------------', id, filePath, fileName)
    try {
      let filePathUpdate;
      filePathUpdate = await this.repo.update(
        { id: (id).toString() },
        { filePath: filePath, fileName: fileName },
      )
      if (filePathUpdate.affected > 0) {
        return new UploadResponse(true, 11, 'uploaded successfully', filePath);
      }
      else {
        return new UploadResponse(false, 11, 'uploaded failed', filePath);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

}
